import VueRouter from 'vue-router'
import Index from '@/views/index.vue'
import Home from '@/views/home.vue'
import Cooperation from '@/views/cooperation.vue'
import Equipment from '@/views/equipment.vue'
import About from '@/views/about.vue'
import Notices from '@/views/notices.vue'
import NoticesDetails from '@/views/details/notices.vue'
import Login from '@/views/login.vue'

// const Index = require('@/views/index.vue')
// const Home = require('@/views/home.vue')
// const Cooperation = require('@/views/cooperation.vue')
// const Equipment = require('@/views/equipment.vue')
// const About = require('@/views/about.vue')
// const Login = require('@/views/login.vue')


const routes = [
    {
        path: '/',
        name: 'index',
        component: Index,
        //重定向
        redirect: '/home',
        children: [{
            path: '/home',
            name: 'homes',
            component: Home,
        },
         // 未匹配到的路径重定向到首页
        ],
    },
    {
        path: '/cooperation',
        name: 'cooperations',
        component: Cooperation,
    },
    {
        path: '/equipment',
        name: 'equipments',
        component: Equipment
    },
    {
        path: '/about',
        name: 'abouts',
        component: About
    },
    {
        path: '/notices',
        name: 'notices',
        component: Notices
    },
    {
        path: '/notices/details',
        name: 'noticesDetails',
        component: NoticesDetails
    },
    {
        path: '/login',
        name: 'logins',
        component: Login
    },
    { path: '*', redirect: '/' }
]




export const router = new VueRouter({
    mode: 'hash',
    routes,
})





